import React from 'react'
import { Menu } from 'antd'
import { Icon } from 'xadmin-ui'
import { use, app, Block, api } from 'xadmin'
import { _t } from 'xadmin-i18n'

export default (() => {

  const { user, onLogout, ...props } = use('auth.user')

  return user && (
    <Block name="top.user.menu">
      {items => (
        <Menu.SubMenu key="user-dorpdown " className="user-menu" {...props}
          title={<>
            <span ><Icon svg={require('../../../icon/User1.svg')} className="anticon nav-icon" style={{ width: '1.5rem' }} /></span>
            <span className="nav-text" >{user.username}</span>
          </>
          }>
          {items}
          <Menu.Item key="changePassword" onClick={() => app.go('/app/user/changepwd')}><Icon type="key" /> {_t('Change password')}</Menu.Item >
          {/* <Menu.Item key="me" onClick={()=>app.go('/app/user/me')}><Icon type="solution"/> 个人主页</Menu.Item> */}
          <Menu.Item key="profile" onClick={() => app.go('/app/user/profile')}><Icon type="setting" /> 个人设置</Menu.Item>
          <Menu.Item key="logout" onClick={onLogout}><Icon type="logout" /> 退出系统</Menu.Item>
        </Menu.SubMenu>
      )}
    </Block>
  )
}
)
